export default {"src":"/_next/static/media/full-width-mobile.285dee02.svg","height":892,"width":270,"blurWidth":0,"blurHeight":0};